import { vueAppWithPinia } from "../Common/vueApp";
import CategoriesSummaryApp from "./CategoriesSummaryApp.vue";

export default vueAppWithPinia(CategoriesSummaryApp);
